import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function capitalize(originalString: string) {
  return originalString.charAt(0).toUpperCase() + originalString.slice(1);
}
